import React, { useEffect, useRef } from 'react';
import { useUser } from '@clerk/clerk-react';
import Odometer from 'react-odometerjs';
import { useLearnedTerms } from '../contexts/LearnedTermsContext';
import { useResourceCelebration } from '../contexts/ResourceCelebrationContext';
import useResourceReceiveAnimation from '../hooks/useResourceReceiveAnimation';
import FaIcon from './FaIcon';
import styles from '../styles/LearnedTermsDisplay.module.css';
import 'odometer/themes/odometer-theme-default.css';

const LearnedTermsDisplay = ({ onClick }) => {
  const { isSignedIn } = useUser();
  const { learnedTermsCount, isLoading } = useLearnedTerms();
  const { registerTarget, targetImpactVersions, getPresentedCounterValue } = useResourceCelebration();
  const buttonRef = useRef(null);
  const displayCount = isSignedIn ? getPresentedCounterValue('learned_terms', learnedTermsCount) : 0;
  const showLoading = isLoading;
  const impactVersion = targetImpactVersions.learned_terms || 0;
  const isReceivingReward = useResourceReceiveAnimation(impactVersion);

  useEffect(() => {
    return registerTarget('learned_terms', buttonRef.current);
  }, [registerTarget]);

  return (
    <button
      ref={buttonRef}
      type="button"
      className={`${styles.learnedTermsButton} ${isReceivingReward ? styles.receivingReward : ''}`}
      onClick={onClick}
      title="Contatore di parole"
      data-resource-target="learned_terms"
    >
      {showLoading ? (
        <span className={styles.loadingDots} />
      ) : (
        <Odometer
          value={displayCount}
          format="(.ddd)"
          duration={500}
          className={styles.count}
        />
      )}
      <span className={styles.icon} aria-hidden="true">
        <FaIcon className={`fa-solid fa-learning-books ${styles.iconGlyph}`} />
      </span>
    </button>
  );
};

export default LearnedTermsDisplay;
